import { SimpleGrid, Grid } from '@mantine/core';
import { useProfile } from '../../hooks/useProfile';
import { LONGEVITY_DOMAINS } from '../../types/portal';
import { DomainCard } from '../../components/portal/DomainCard';
import { MedicationsSummaryCard } from '../../components/portal/MedicationsSummaryCard';
import { InsuranceSummaryCard } from '../../components/portal/InsuranceSummaryCard';
import { RecentActivityCard } from '../../components/portal/RecentActivityCard';

export function PortalDashboard() {
  const { profileData } = useProfile();
  const firstName = profileData.firstName || 'there';

  return (
    <div className="py-2">
      {/* Welcome */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-100 mb-1">
          Welcome back, {firstName}
        </h1>
        <p className="text-sm text-gray-500">
          Your personalized longevity dashboard
        </p>
      </div>

      {/* Domain Cards Grid */}
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md" mb="xl">
        {LONGEVITY_DOMAINS.map((domain) => (
          <DomainCard key={domain.id} domain={domain} />
        ))}
      </SimpleGrid>

      {/* Bottom Row: Activity + Summaries */}
      <Grid gutter="md">
        <Grid.Col span={{ base: 12, md: 8 }}>
          <RecentActivityCard />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}>
          <div className="space-y-4">
            <MedicationsSummaryCard />
            <InsuranceSummaryCard />
          </div>
        </Grid.Col>
      </Grid>
    </div>
  );
}
